import { memo, useContext } from "react";
import styles from "./main-page.module.css";
import { LocalizationContext } from "../context/LocalizationContext";
import { FidPlatformUrl } from "../../common";
import { appendMarketingParamsToUrl } from "../../affiliate-config";

function generateConfirmationUrl(transactionId: string): string {
  const url = `//${FidPlatformUrl()}/#process-transaction?transactionId=${transactionId}`;
  return appendMarketingParamsToUrl(url);
}

export const ConfirmButton = memo((props: { transactionId: string }) => {
  const { transactionId } = props;
  const localizationContext = useContext(LocalizationContext);

  return (
    <a
      href={generateConfirmationUrl(transactionId)}
      target="_blank"
      className={styles.confirmButton}
      rel="noreferrer"
    >
      <span>{localizationContext?.localization?.modalconfirmbutton}</span>
    </a>
  );
});
